export const TemplatesPrefixes = {
  Management: 'templates-manage',
  Editor: 'templates-editor',
  Inbox: 'templates-inbox',
  Importer: 'templates-importer',
  LandingPageEditor: 'templates-landing-page-editor',
};
